/**
 * @generated SignedSource<<6059b8a54822e1815cf9e5cb0cd22c42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SideBarWrapper_query$data = {
  readonly UrlConfig: {
    readonly jun0: string | null | undefined;
    readonly redash: string | null | undefined;
    readonly sinistral: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadsList_query" | "NavBarUserMenu_query" | "useEnabledDashboards_query">;
  readonly " $fragmentType": "SideBarWrapper_query";
};
export type SideBarWrapper_query$key = {
  readonly " $data"?: SideBarWrapper_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"SideBarWrapper_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterElement"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SideBarWrapper_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavBarUserMenu_query"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filterElement"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useEnabledDashboards_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatThreadsList_query"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jun0",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "redash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sinistral",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b8a95f945e246efb9f5b96ccec382bbc";

export default node;
